import { useCallback, useState } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const InteractorStoreWarehouse = () => {
  const { t } = useTranslation()
  const { seller } = useSelector((state) => state.seller)
  const [warehouseListData, setWarehouseListData] = useState([])
  const [warehousePages, setWarehousePages] = useState({
    currentPage: 1,
    limitProduct: 0,
    totalPages: 1,
    totalItem: 0,
  })
  const listWarehouseByStore = useCallback(
    (callback, setDefault = () => {}, loadingCallback = () => {}) => {
      loadingCallback(true)
      ApiService.jsonRequest(
        '/store-warehouse/search',
        {
          page: 1,
          limit: 1000,
          keywords: {
            text_search: '',
            store_uid: seller.uid,
          },
        },
        (response) => {
          loadingCallback(false)
          if (response.status_code === 200) {
            callback(response.data.items)
            setDefault(response.data.items.filter((item) => item.warehouse_primary === 'Y')[0])
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.message}`),
              timer: 2000,
            })
          }
        },
      )
    },
    [seller.uid, t],
  )

  const listWarehouseByStorePaginate = useCallback(
    (payload, callback, setDefault = () => {}, loadingCallback = () => {}) => {
      loadingCallback(true)
      ApiService.jsonRequest('/store-warehouse/search', payload, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          const { pages } = response.data
          setWarehousePages({
            currentPage: pages.page,
            limitProduct: pages.limit,
            totalPages: pages.total_pages,
            totalItem: pages.total_items,
          })
          callback(response.data.items)
          setDefault(response.data.items.filter((item) => item.warehouse_primary === 'Y')[0])
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.message}`),
            timer: 2000,
          })
        }
      })
    },
    [t],
  )

  const warehouseView = useCallback(
    (uid, loadingCallback = () => {}) => {
      const payload = {
        uid,
      }
      loadingCallback(true)
      ApiService.jsonRequest('/store-warehouse/view', payload, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          setWarehouseListData(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [setWarehouseListData, t],
  )

  // const listWarehouseByStorePaginate = useCallback(
  //   (payload, callback, setDefault = () => {}, loadingCallback = () => {}) => {
  //     loadingCallback(true)
  //     ApiService.jsonRequest('/store-warehouse/search', payload, (response) => {
  //       loadingCallback(false)
  //       if (response.status_code === 200) {
  //         const { pages } = response.data
  //         setWarehousePages({
  //           currentPage: pages.page,
  //           limitProduct: pages.limit,
  //           totalPages: pages.total_pages,
  //           totalItem: pages.total_items,
  //         })
  //         callback(response.data.items)
  //         setDefault(response.data.items.filter((item) => item.warehouse_primary === 'Y')[0])
  //       } else {
  //         showAlert({
  //           icon: 'error',
  //           message: t(`response_message.${response.message}`),
  //           timer: 2000,
  //         })
  //       }
  //     })
  //   },
  //   [t],
  // )

  return {
    listWarehouseByStore,
    listWarehouseByStorePaginate,
    warehousePages,
    warehouseView,
    warehouseListData,
  }
}

export default InteractorStoreWarehouse
